import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LogOut, Menu, X } from "lucide-react";
import { JACE } from "./shared";

const NAV = [
  { to: "/jace/dashboard", label: "DASHBOARD", live: true },
  { to: "/jace/sessions", label: "SESSIONS", live: true },
  { to: "/jace/library", label: "EXERCISE LIBRARY", live: true },
  { to: "/jace/engine", label: "COACHING ENGINE", live: true },
  { to: "/jace/feedback", label: "FEEDBACK", live: true },
  { to: "/jace/programs", label: "PROGRAMS", live: false },
  { to: "/jace/progressions", label: "PROGRESSIONS", live: false },
  { to: "/jace/assessments", label: "ASSESSMENTS", live: false },
  { to: "/jace/athletes", label: "ATHLETES", live: true },
  { to: "/jace/groups", label: "GROUPS", live: true },
  { to: "/jace/coaches", label: "COACHES", live: false },
  { to: "/jace/reviews", label: "REVIEWS", live: false },
  { to: "/jace/analytics", label: "ANALYTICS", live: false },
  { to: "/jace/archive", label: "ARCHIVE", live: true },
];

function NavItems({ onNavigate }) {
  const location = useLocation();
  return NAV.map((n) =>
    n.live ? (
      <Link key={n.to} to={n.to} onClick={onNavigate}
        className={`block px-3 py-2 text-sm transition-colors border-l-2 ${location.pathname.startsWith(n.to) ? "text-[#F5F3F0] bg-[#F5F3F0]/10" : "text-[#A3A3A3] hover:text-[#F5F3F0] border-transparent"}`}
        style={location.pathname.startsWith(n.to) ? { borderColor: JACE } : {}}
        data-testid={`jace-nav-${n.label.toLowerCase().replace(/ /g, "-")}`}>
        {n.label}
      </Link>
    ) : (
      <span key={n.to} className="block px-3 py-2 text-sm text-[#4A4A4A] border-l-2 border-transparent cursor-not-allowed"
        title="Komt in een volgende fase" data-testid={`jace-nav-${n.label.toLowerCase().replace(/ /g, "-")}`}>
        {n.label} <span className="chip text-[#4A4A4A]">—</span>
      </span>
    )
  );
}

export default function JaceLayout({ children, title }) {
  const nav = useNavigate();
  const [navOpen, setNavOpen] = useState(false);
  const logout = () => {
    const t = localStorage.getItem("joh_admin_token");
    localStorage.removeItem("joh_admin_token");
    // Was de membersessie hetzelfde token? Dan ook daar uitloggen.
    if (t && localStorage.getItem("joh_auth_token") === t) localStorage.removeItem("joh_auth_token");
    nav("/jace");
  };

  return (
    <div className="jace-scope min-h-screen bg-[#0A0A0A] text-[#F5F3F0] grain grain-dark" data-testid="jace-layout">
      <header className="line-b line-dark px-6 md:px-10 py-4 flex items-center justify-between sticky top-0 bg-[#0A0A0A]/95 backdrop-blur z-40">
        <div className="flex items-center gap-4">
          <button onClick={() => setNavOpen(true)} className="md:hidden chip text-[#F5F3F0] border border-[#F5F3F0]/25 px-3 py-2" data-testid="jace-menu-open"><Menu size={14}/></button>
          <Link to="/jace/dashboard" className="font-display text-2xl" style={{ color: JACE }}>JACE</Link>
          <span className="chip text-[#A3A3A3] hidden sm:inline">JOH ATHLETIC COACHING ENGINE</span>
        </div>
        <div className="flex items-center gap-4">
          <span className="chip hidden md:inline" style={{ color: JACE }}>// SYSTEM ACTIVE</span>
          <Link to="/admin" className="chip text-[#A3A3A3] accent-hover hidden md:inline" data-testid="jace-to-admin">ADMIN</Link>
          <button onClick={logout} title="Uitloggen" aria-label="Uitloggen"
            className="w-10 h-10 border border-[#F5F3F0]/45 flex items-center justify-center text-[#F5F3F0] hover:bg-[#F5F3F0] hover:text-[#0A0A0A] transition-colors"
            data-testid="jace-logout-btn"><LogOut size={15}/></button>
        </div>
      </header>

      <div className="flex">
        <aside className="hidden md:block w-56 shrink-0 border-r border-[#F5F3F0]/10 sticky top-[65px] h-[calc(100vh-65px)] overflow-y-auto py-6 px-4" data-testid="jace-sidebar">
          <NavItems />
        </aside>

        {navOpen && (
          <div className="fixed inset-0 z-50 md:hidden" data-testid="jace-nav-drawer">
            <div className="absolute inset-0 bg-black/70" onClick={() => setNavOpen(false)} />
            <div className="absolute left-0 top-0 bottom-0 w-64 bg-[#0A0A0A] border-r border-[#F5F3F0]/15 py-6 px-4 overflow-y-auto">
              <div className="flex items-center justify-between mb-6 px-3">
                <span className="font-display text-xl" style={{ color: JACE }}>JACE</span>
                <button onClick={() => setNavOpen(false)} className="chip text-[#A3A3A3]" data-testid="jace-menu-close"><X size={14}/></button>
              </div>
              <NavItems onNavigate={() => setNavOpen(false)} />
              <button onClick={logout} className="w-full text-left px-3 py-2.5 text-sm text-[#A3A3A3] hover:text-[#F5F3F0] border-l-2 border-transparent inline-flex items-center gap-2 mt-4" data-testid="jace-drawer-logout">
                <LogOut size={14}/> UITLOGGEN
              </button>
            </div>
          </div>
        )}

        <main className="flex-1 min-w-0 px-6 md:px-10 py-8">{children}</main>
      </div>
    </div>
  );
}
